"use client";

import { Post } from "contentlayer/generated";
import ListLayoutWithTags from "./layouts/ListLayoutWithTags";
import usePageNumberFromParams from "./usePaginationFromSearchParams";

interface Props {
  posts: Post[];
}

export default function ClientIndexPostPage({ posts }: Props) {
  const { currentPagePosts, pagination } = usePageNumberFromParams(posts);

  return (
    <ListLayoutWithTags
      selectedTag={undefined}
      currentPagePosts={currentPagePosts}
      pagination={pagination}
      title="Learning Center"
      subtitle="Explore our learning center for in-depth guides on creating better music, mixing tips, essential skills, and effective vocal practice."
    />
  );
}
